// @flow

const FILES_DOWNLOAD_START = 'FILES_DOWNLOAD_START';
const FILES_DOWNLOAD_COMPLETE = 'FILES_DOWNLOAD_COMPLETE';
const FILES_DOWNLOAD_RESET = 'FILES_DOWNLOAD_RESET';

export type FilesDownloadStartEvent = {|
  type: typeof FILES_DOWNLOAD_START,
  payload: {},
|};

export const filesDownloadStart = (): FilesDownloadStartEvent => ({
  type: FILES_DOWNLOAD_START,
  payload: {},
});

export type FilesDownloadCompleteEvent = {|
  type: typeof FILES_DOWNLOAD_COMPLETE,
  payload: {success: boolean, error: string | null},
|};

export const filesDownloadComplete = (
  success: boolean,
  error: string | null,
) => ({
  type: FILES_DOWNLOAD_COMPLETE,
  payload: {success, error},
});

export type FilesDownloadResetEvent = {|
  type: typeof FILES_DOWNLOAD_COMPLETE,
  payload: {success: boolean, error: string | null},
|};

export const filesDownloadReset = () => ({
  type: FILES_DOWNLOAD_RESET,
  payload: {},
});

export type FileDownloadEvent =
  | FilesDownloadStartEvent
  | FilesDownloadCompleteEvent
  | FilesDownloadResetEvent;

export type FileDownloadReducerState = {|
  isDownloading: boolean,
  error: string | null,
  success: boolean,
|};

export const FileDownloadReducer = (
  state: FileDownloadReducerState,
  event: FileDownloadEvent,
) => {
  switch (event.type) {
    case FILES_DOWNLOAD_START:
      return {
        ...state,
        isDownloading: true,
        success: false,
        error: null,
      };
    case FILES_DOWNLOAD_COMPLETE:
      return {
        ...state,
        isDownloading: false,
        success: event.payload.success,
        error: event.payload.error,
      };
    case FILES_DOWNLOAD_RESET:
      return {
        ...state,
        isDownloading: false,
        success: false,
        error: null,
      };
    default:
      throw new Error(`Unknown file download event ${event.type}`);
  }
};
